import { StandardAlert } from '@cimplico/components';
import { useState } from 'react';

type PostJournalsErrorAlertProps = {
    errors: { [key: number]: string[] };
    onClose: () => void;
};

function PostJournalsErrorAlert({ errors, onClose }: PostJournalsErrorAlertProps): JSX.Element {
    const [viewMore, setViewMore] = useState(false);

    return (
        <div className="mb-4">
            <StandardAlert
                type="error"
                title="There are errors while posting journals to Xero."
                description={viewMore ? formatMessages(errors) : undefined}
                onClose={onClose}
            >
                {!viewMore && <StandardAlert.Button onClick={(): void => setViewMore(!viewMore)}>View more</StandardAlert.Button>}

                {viewMore && <StandardAlert.Button onClick={(): void => setViewMore(!viewMore)}>View less</StandardAlert.Button>}
            </StandardAlert>
        </div>
    );
}

function formatMessages(messages: { [key: string]: string[] }): string[] {
    const errorMessages: string[] = [];
    for (const key in messages) {
        errorMessages.push(`${key} : ${messages[key]}`);
    }
    return errorMessages;
}

export default PostJournalsErrorAlert;
